<div class="report-table">
  @if (hasTitleDictionaryKey()) {
    <sc-sub-title >
      <sc-dictionary-label [dictionaryKey]="titleDictionaryKey"></sc-dictionary-label>
    </sc-sub-title>
  }
  @if (!hasTitleDictionaryKey() && hasTitle()) {
    <sc-sub-title >{{title}}</sc-sub-title>
  }
  <sc-content-spacer vertical></sc-content-spacer>
  <table class="{{classes}}">
    @if (!hideHeaders) {
      <thead>
        <tr>
          <th style="width: 200px"></th>@for (column of columns; track column) {
          <th [ngStyle]="{'min-width': columnWidth}">
            @if (hasDictionaryLabel(column)) {
              <sc-dictionary-label [dictionaryKey]="column.dictionaryKey"></sc-dictionary-label>
            }
            @if (!hasDictionaryLabel(column)) {
              {{column.label}}
            }
          </th>
        }
      </tr>
    </thead>
  }
  <tbody>
    @for (row of rows; track row; let i = $index) {
      <tr >
        <td>
          <sc-dictionary-label [dictionaryKey]="row.dictionaryKey"></sc-dictionary-label>
        </td>
        @for (column of columns; track column) {
          <td class="text-right" [ngStyle]="{'min-width': columnWidth}">{{value(i, column.key)}}</td>
        }
      </tr>
    }
  </tbody>


</table>


</div>
